import { render, staticRenderFns } from "./WithScrollingCard.vue?vue&type=template&id=3b6323be&scoped=true&"
import script from "./WithScrollingCard.vue?vue&type=script&lang=js&"
export * from "./WithScrollingCard.vue?vue&type=script&lang=js&"
import style0 from "./WithScrollingCard.vue?vue&type=style&index=0&id=3b6323be&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6323be",
  null
  
)

export default component.exports